var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"dashboard-header"},[_vm._v("Today's Weather")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.weather.main)?_c('h2',[_vm._v(_vm._s(_vm._f("noDecimals")(_vm.weather.main.temp - 273.15))+"°C  "),_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.weather.weather[0].description))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ffb4294","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myrundash/dashboard/Weather.vue
// module id = 492
// module chunks = 0